import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Button, Box, Card, CardContent, Grid, Typography, InputLabel, MenuItem, FormControl, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
const WorkshopReports = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState(null);
    const [workshops, setWorkshops] = useState([]);
    const [registrationType, setRegistrationType] = useState('');
    const [totalSeatCount, setWorkshopTotalSeatCount] = useState([])
    //const [workshopTotalSeatCount, setWorkshopTotalSeatCount] = useState();
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code_two: ""
    });

    useEffect(() => {
        axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                setWorkShopCategoryData(res.data.workshopCategories);
            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        }).catch(error => {
            console.error('API Error:', error);
            swal('Error', 'An error occurred while fetching workshop categories', 'error');
        });

        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                setAbstractHomeSetup(res.data.HomePageSetup);
            }
        }).catch(error => {
            console.error('API Error:', error);
            swal('Error', 'An error occurred while fetching home setup data', 'error');
        });
    }, [eventid]);

    const handleRegistration = (e) => {
        const selectedRegistrationType = e.target.value;
        setRegistrationType(selectedRegistrationType);

        axios.get(`api/workshop-report-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    setSingleWorkShopCategory(res.data.swsd);
                    setWorkshops(res.data.swsd.work_shops); // Set workshops array
                    setWorkshopTotalSeatCount(res.data.totalSeatCount);
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });
    };

    const backGroundButtonByEvent = abstractHomeSetup.color_code_two || '#145348';

    const downloadCSV = () => {
        if (!singleWorkShopCategory) {
            swal("Error", "Please select a category first", "error");
            return;
        }

        // Prepare CSV content with category name at the top
        let csvContent = `Category Name: ${singleWorkShopCategory.workshop_category_title}\n\n`;
        // csvContent += `Category Description: ${singleWorkShopCategory.workshop_category_description}\n\n`;
        csvContent += "Workshop Name,Event Name,Total Seats,Booked Seats\n";

        workshops?.forEach((workshop) => {
            const bookedSeats = totalSeatCount.filter(seat => seat.workshop_id === workshop.id).length;
            csvContent += `${workshop.workshop_name},${workshop.event_name},${workshop.workshop_no_ofseats},${bookedSeats}\n`;
        });

        // Create a Blob URL for the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.download = "Workshop_Report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the Blob URL after the download
        URL.revokeObjectURL(url);
    };


    // const downloadCSV = () => {
    //     const headers = ["Workshop Name", "Event Name", "Total Seats", "Booked Seats"];
    //     const csvRows = workshops.map((workshop) => {
    //         const bookedSeats = totalSeatCount.filter(seat => seat.workshop_id === workshop.id).length;
    //         return [
    //             workshop.workshop_name,
    //             workshop.event_name,
    //             workshop.workshop_no_ofseats,
    //             bookedSeats
    //         ].join(",");
    //     });

    //     const csvContent = [headers.join(","), ...csvRows].join("\n");
    //     const blob = new Blob([csvContent], { type: "text/csv" });
    //     const url = URL.createObjectURL(blob);

    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.download = "Workshop_Report.csv";
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };



    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000' }} style={{ marginTop: '5%' }}>
                <Box display="flex" justifyContent="flex-end" mt={2}>

                    <Button
                        sx={{ float: 'right', marginLeft: '10px', backgroundColor: backGroundButtonByEvent, }}
                        color="primary"
                        variant="contained"
                        onClick={downloadCSV}
                    >
                        Download CSV
                    </Button>
                    <Button
                        sx={{
                            float: 'right',
                            marginLeft: '10px',
                            backgroundColor: backGroundButtonByEvent,
                            ":hover": { color: "white" }
                        }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </Box>
                <Card sx={{ width: '60vw', margin: 'auto' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Workshop Report
                        </Typography>
                        <Box component="form" noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} lg={6} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel id="workshop-category-label">Workshop Category</InputLabel>
                                        <Select
                                            value={registrationType || ""}
                                            onChange={handleRegistration}
                                            labelId="workshop-category-label"
                                            id="workshop-category-select"
                                            label="Workshop Category"
                                        >
                                            {workshopCategoryData.map((val) => (
                                                <MenuItem value={val.id} key={val.id}>{val.workshop_category_title}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {/* Display selected workshop details */}
                            {singleWorkShopCategory && (
                                <Box sx={{ mt: 4 }}>
                                    <Typography variant="h6" gutterBottom>
                                        Selected Workshop Category: {singleWorkShopCategory.workshop_category_title}
                                    </Typography>
                                    <Typography variant="body1">{singleWorkShopCategory.workshop_category_description}</Typography>
                                </Box>
                            )}

                            {/* Workshop Table */}
                            {workshops?.length > 0 && (
                                <TableContainer component={Paper} sx={{ mt: 4 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Workshop Name</TableCell>
                                                <TableCell>Event Name</TableCell>
                                                <TableCell>Total Seats</TableCell>
                                                <TableCell>Book Seats</TableCell>
                                                <TableCell>More Details</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {workshops?.map((workshop) => {
                                                const seatCount = totalSeatCount?.filter(seat => seat.workshop_id === workshop.id).length; // Calculate seat count

                                                return (
                                                    <TableRow key={workshop.id}>
                                                        <TableCell>{workshop.workshop_name}</TableCell>
                                                        <TableCell>{workshop.event_name}</TableCell>
                                                        <TableCell>{workshop.workshop_no_ofseats}</TableCell>
                                                        <TableCell>{seatCount}</TableCell>
                                                        <TableCell>
                                                            <Button
                                                                sx={{
                                                                    margin: 1,
                                                                    ":hover": {
                                                                        color: "white"
                                                                    },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                component={Link}
                                                                to={`/admin/workshop/more-details/${workshop.id}`}
                                                                disabled={seatCount === 0} // Disable button if no seats are available
                                                            >
                                                                <VisibilityIcon />
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default WorkshopReports;
